import { renderObjectIcon } from '../utils/icons';
import BusinessProcessBase, { TextLabelBehaviors } from './BusinessProcessBase';

const WIDTH = 50;
const HEIGHT = 65;

@TextLabelBehaviors
class ShapeBusinessProcessData extends BusinessProcessBase {
  static defaultWidth() {
    return WIDTH;
  }

  static defaultHeight() {
    return HEIGHT;
  }

  static pathString() {
    const ratio = WIDTH / HEIGHT;
    const r = 0.08;
    const f = 0.3;

    return `
      M -${0.5 - r} -0.5
      L ${0.5 - f} -0.5
      L 0.5 -${0.5 - f * ratio}
      L 0.5 ${0.5 - r}
      R ${r} 1 1
      L -${0.5 - r} 0.5
      R ${r} 2 1
      L -0.5 -${0.5 - r}
      R ${r} 3 1
      Z

      M 0.5 -${0.5 - f * ratio}
      L ${0.5 - f + r} -${0.5 - f * ratio}
      R ${r} 2 1
      L ${0.5 - f} -${0.5 - f * ratio + r}
      L ${0.5 - f} -0.5
      `;
  }

  render(ctx: CanvasRenderingContext2D) {
    super.render(ctx);

    // primary icon top left
    if (this.icon) {
      renderObjectIcon(ctx, this.icon, 38, [-7, -6.5], this.fabricObject);
    }

    // secondary icon bottom center
    if (this.secondaryIcon) {
      renderObjectIcon(
        ctx,
        this.secondaryIcon,
        38,
        ['center', HEIGHT * this.scaleY - 33],
        this.fabricObject
      );
    }
  }
}

export default ShapeBusinessProcessData;
